import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
  ) {}

  getNotifications(prfyear: number, groupcode: string): Observable<any> {
    const data = {
      prfyear,
      groupcode,
    };
    return this.http.post(`${this.baseUrl}getactionitemslist`, data).pipe(
      map((response) => this.mapResponseToGridConfigType(response)),
      catchError((error) => throwError(() => new Error(error)))
    );
  }

  private mapResponseToGridConfigType(response) {
    return {
      items: response.actionitems,
    };
  }
}
